import { render, staticRenderFns } from "./materialDetail.vue?vue&type=template&id=5dc32781&scoped=true"
import script from "./materialDetail.vue?vue&type=script&lang=js"
export * from "./materialDetail.vue?vue&type=script&lang=js"
import style0 from "./materialDetail.vue?vue&type=style&index=0&id=5dc32781&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc32781",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dc32781')) {
      api.createRecord('5dc32781', component.options)
    } else {
      api.reload('5dc32781', component.options)
    }
    module.hot.accept("./materialDetail.vue?vue&type=template&id=5dc32781&scoped=true", function () {
      api.rerender('5dc32781', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/base-data/materialDetail.vue"
export default component.exports